import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import stockverifyService from "../services/stock-verify.service";
import { setMessage } from "./message";
export const fetchstocReportList = createAsyncThunk(
    'stockverify/fetchstocReportList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await stockverifyService.getReportList(page, pagesize, search, ordering);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const fetchstockverifyList = createAsyncThunk(
    'stockverify/fetchstockverifyList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await stockverifyService.getVerifiedByndleList(page, pagesize, search, ordering);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const fetchstockUnverifyList = createAsyncThunk(
    'stockverify/fetchstockUnverifyList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await stockverifyService.getUnverifiedBundleList(page, pagesize, search, ordering);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchArchivedstockverifyList = createAsyncThunk(
    'stockverify/fetchArchivestockverifyList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await stockverifyService.getDieArchiveSizeList(page, pagesize, search, ordering);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const createstockverify = createAsyncThunk(
    'stockverify/createstockverify',
    async (sizeData, thunkAPI) => {
        try {
            const response = await stockverifyService.createSize(sizeData);
            return response.results; // Assuming response contains the created die size data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const editstockverify = createAsyncThunk(
    'stockverify/editstockverify',
    async ({ bundle_number,report_id }, thunkAPI) => {
        try {
            const response = await stockverifyService.editDieSize(bundle_number);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const editstockverifyTwo = createAsyncThunk(
    'stockverify/editstockverifyTwo',
    async ({ bundle_number,report_id }, thunkAPI) => {
        try {
            const response = await stockverifyService.editDieSizeTwo(bundle_number,report_id);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const bunldeVerifyListById = createAsyncThunk(
    'stockverify/bunldeVerifyListById',
    async ({ report_id, page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await stockverifyService.getVerifiedByndleListById(report_id, page, pagesize, search, ordering);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const bunldeUnVerifyListById = createAsyncThunk(
    'stockverify/bunldeUnVerifyListById',
    async ({ report_id , page, pagesize, search, ordering}, thunkAPI) => {
        try {
            const response = await stockverifyService.getUnVerifiedByndleListById(report_id, page, pagesize, search, ordering);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deletestockverify = createAsyncThunk(
    'stockverify/deletestockverify',
    async (id, thunkAPI) => {
        try {
            await stockverifyService.deletestockverify(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchivestockverify = createAsyncThunk(
    'stockverify/unArchivestockverify',
    async (id, thunkAPI) => {
        try {
            await stockverifyService.unArchivestockverify(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);


const initialState = {
    data: [],  // Ensure the data is always an empty array initially
    list: [],
    loading: false,
    totalRecord: 0,
    totalPages: 0,
    currentPage: 1,
    status: 'idle',
    error: null,
    hasMore: true,
};

const stockverifySlice = createSlice({
    name: 'stockverify',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetstockverifyList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentstockverifyPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: (builder) => {


        builder
            .addCase(fetchstockverifyList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchstockverifyList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Correctly access the data array
                state.totalRecord = action.payload.count || 0; // Set total records
                state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchstockverifyList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

            
        builder
        .addCase(fetchstocReportList.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(fetchstocReportList.fulfilled, (state, action) => {
            state.status = 'succeeded';
            const fetchedPage = action.payload.page || state.currentPage;
            state.Reportdata = action.payload.results.data || []; // Correctly access the data array
            state.ReporttotalRecord = action.payload.count || 0; // Set total records
            state.ReporttotalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
            state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
            state.list = [...state.list, ...action.payload.results.data];
            state.hasMore = !!action.payload.next;
        })
        .addCase(fetchstocReportList.rejected, (state, action) => {
            state.status = 'failed';
            state.loading = false;
            state.error = action.error.message;
        });

            builder
            .addCase(fetchstockUnverifyList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchstockUnverifyList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.UnVerifydata = action.payload.results.data || []; // Correctly access the data array
                state.UnVerifydatatotalRecord = action.payload.count || 0; // Set total records
                state.UnVerifydatatotalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchstockUnverifyList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchArchivedstockverifyList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedstockverifyList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Correctly access the data array
                state.totalRecord = action.payload.count || 0; // Set total records
                state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedstockverifyList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(createstockverify.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createstockverify.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createstockverify.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });

        builder
            .addCase(editstockverify.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(editstockverify.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const index = state.data.findIndex((Size) => Size.id === action.payload.id);
                if (index !== -1) {
                    state.data[index] = action.payload; // Update the die size in the state
                }
            })
            .addCase(editstockverify.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });

            builder
            .addCase(editstockverifyTwo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(editstockverifyTwo.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const index = state.data.findIndex((Size) => Size.id === action.payload.id);
                if (index !== -1) {
                    state.data[index] = action.payload; // Update the die size in the state
                }
            })
            .addCase(editstockverifyTwo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });

            builder
            .addCase(bunldeVerifyListById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(bunldeVerifyListById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const index = state.data.findIndex((Size) => Size.id === action.payload.id);
                if (index !== -1) {
                    state.data[index] = action.payload; // Update the die size in the state
                }
            })
            .addCase(bunldeVerifyListById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });

            builder
            .addCase(bunldeUnVerifyListById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(bunldeUnVerifyListById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const index = state.data.findIndex((Size) => Size.id === action.payload.id);
                if (index !== -1) {
                    state.data[index] = action.payload; // Update the die size in the state
                }
            })
            .addCase(bunldeUnVerifyListById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deletestockverify.pending, state => {
                state.status = 'loading';
            })
            .addCase(deletestockverify.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deletestockverify.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchivestockverify.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchivestockverify.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchivestockverify.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const { resetstockverifyList, resetCurrentstockverifyPage } = stockverifySlice.actions;
const { reducer } = stockverifySlice;
export default reducer;
